enum JobScheduleEventType {
	Interview = 1,
	Placement = 2
}

export default JobScheduleEventType;